export enum RandomizationAttributes {
  sex = 'sex',
  donor_id = 'donor_id',
  dob = 'dob',
}
